import { AlertColor } from "@mui/material";

import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface State {
  alerts: alert[];
}
export interface alert {
  severity: AlertColor;
  message: string;
  id?: number;
  time?: number;
  action?: {
    label: string;
    onClick: () => void;
  };
}

const initialState: State = {
  alerts: []
};

const AlertSlice = createSlice({
  name: "alert",
  initialState,
  reducers: {
    //push alert
    alertPopup: (state, action: PayloadAction<{ alert: alert }>) => {
      state.alerts = [...(state.alerts || []), { ...action.payload.alert, id: new Date(Date.now()).getTime() }];
    },
    //add one message to chatbox. use when user handle submit message from chatbox
    clearAlert: (state, action: PayloadAction<{ id: number }>) => {
      state.alerts = state.alerts.filter((f) => f.id !== action.payload.id);
    }
  }
});
export const { alertPopup, clearAlert } = AlertSlice.actions;
export default AlertSlice.reducer;
